<div class="geral-container">
  <div class="left-container">
    <div class="dropdown-container">
      <div class="dropdown-box" style="margin-right: 8px;">
        <app-dropdown-button id="dropdown-fac-funnel" [isOpen]="dropdownsState.funnel" 
        [label]="geralForm.get('column_type').value.value" 
        (valueChange)="dropdownsState.funnel = $event">
          <ul class="dropdown-text-list" *ngIf="!dropdownsState.sub_funnel">
            <div *ngFor="let item of combosList.funnel_stages">
              <li *ngIf="!item.sub_items" (click)="setFunnel(item)">{{item.value}}</li>
              <li *ngIf="item.sub_items" class="flex-space-between" (click)="$event.stopPropagation() ; setFunnel(item)">
                {{item.value}}<img style="transform: rotate(270deg)" src="../../../../assets/svgs/dropdown_arrow_ico.svg" alt="dropdown_arrow_ico">                   
              </li>
            </div>           
          </ul>

          <ul class="dropdown-text-list" *ngIf="dropdownsState.sub_funnel">
            <div *ngFor="let sub of combosList.funnel_stages[1].sub_items">
              <li (click)="setSubFunnel(sub)">{{sub}}</li>
            </div>
          </ul> 
        </app-dropdown-button>
      </div>

      <div class="dropdown-box">
        <app-dropdown-button id="dropdown-fac-temp" [icon]="facItem.temperature ? getTempIcon(facItem.temperature.name) : null" [label]="facItem.temperature ? facItem.temperature.name : 'Temperatura'" [(isOpen)]="dropdownsState.temp" (valueChange)="dropdownsState.temp = $event">
          <ul class="dropdown-text-list">
            <li class="temp-li" (click)="changeTemp(item)" *ngFor="let item of combosList.temperatures">
              <img src="../../../../assets/svgs/{{getTempIcon(item.name)}}.svg" alt="{{getTempIcon(item.name)}}">
              {{item.name}}
            </li>
          </ul>
        </app-dropdown-button>
      </div>

      <div class="icon-box">
        <app-dropdown-icon id="dropdown-fac-actions" class="app-dropdown-icon" [alignRight]="true" [isOpen]="dropdownsState.discard" [icon]="'gear_ico'" [iconTitle]="'Ações da fac'" (valueChange)="dropdownsState.discard = $event">
          <ul class="dropdown-text-list" (click)="dropdownsState.discard = false">
            <li *ngIf="!facItem.archived" (click)="showArchiveAlert(true)">Arquivar</li>
            <li *ngIf="facItem.archived" (click)="showArchiveAlert(false)">Desarquivar</li>
            <li (click)="showDiscardPopup = true">Descartar</li>
            <li (click)="showTransferPopup = true" *ngIf="facItem.transferable">Transferir</li>
          </ul>
        </app-dropdown-icon>
      </div>
    </div>

    <div class="descriptions-container" *ngIf="facItem.temperature">
        <div class="description-item" (click)="tag.active = !tag.active; patchFac({temperature: facItem.temperature})" [ngClass]="{selected: tag.active}" *ngFor="let tag of facItem.temperature.tags">
          <span>{{tag.name}}</span>
          <svg *ngIf="tag.active" width="9" height="9" viewBox="0 0 9 9" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0 7.91875C0 7.63075 0.104 7.38275 0.312 7.17475L2.652 4.83475L0.312 2.48275C0.104 2.28275 0 2.03875 0 1.75075C0 1.46275 0.104 1.21875 0.312 1.01875C0.52 0.81875 0.764 0.71875 1.044 0.71875C1.324 0.71875 1.568 0.81875 1.776 1.01875L4.128 3.37075L6.468 1.01875C6.668 0.81875 6.912 0.71875 7.2 0.71875C7.488 0.71875 7.732 0.81875 7.932 1.01875C8.132 1.21875 8.232 1.46275 8.232 1.75075C8.232 2.03875 8.132 2.28275 7.932 2.48275L5.592 4.83475L7.932 7.17475C8.132 7.38275 8.232 7.63075 8.232 7.91875C8.232 8.20675 8.132 8.45075 7.932 8.65075C7.732 8.85075 7.488 8.95075 7.2 8.95075C6.912 8.95075 6.668 8.85075 6.468 8.65075L4.128 6.31075L1.776 8.65075C1.576 8.85075 1.332 8.95075 1.044 8.95075C0.756 8.95075 0.508 8.85075 0.3 8.65075C0.1 8.44275 0 8.19875 0 7.91875Z" fill="#00866E"/>
          </svg>                  
        </div>
    </div>

    <div class="title-tabs">
      <div class="tabs-container">
        <span class="title" [ngClass]="{'active': activeTab === 1}" (click)="activeTab = 1; isEditing = false">
          <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12.3366 0.333496C13.0713 0.333496 13.6666 0.932163 13.6666 1.66016V12.3402C13.6666 13.0728 13.0713 13.6668 12.3366 13.6668H1.66659V11.0002H0.333252V9.66683H1.66659V7.66683H0.333252V6.3335H1.66659V4.3335H0.333252V3.00016H1.66659V0.333496H12.3366ZM4.33325 1.66683H2.99992V12.3335H4.33325V1.66683ZM12.3333 1.66683H5.66659V12.3335H12.3333V1.66683Z" fill="#6E6E6E"/>
          </svg>Registro da atividade</span>
        <span class="title" [ngClass]="{'active': activeTab === 2}" (click)="activeTab = 2; isEditing = false; clearChatForm(); scrollChat()">
          <svg width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M7.33341 9.50117V10.8945C6.73003 10.6812 6.08426 10.6157 5.45035 10.7037C4.81644 10.7917 4.21288 11.0304 3.69037 11.4C3.16786 11.7695 2.74164 12.259 2.44752 12.8274C2.1534 13.3958 1.99996 14.0265 2.00008 14.6665L0.666748 14.6658C0.666541 13.8518 0.852696 13.0484 1.21095 12.3174C1.5692 11.5864 2.09004 10.9471 2.73356 10.4485C3.37708 9.94993 4.1262 9.60526 4.92352 9.44093C5.72083 9.27661 6.54519 9.29698 7.33341 9.5005V9.50117ZM6.00008 8.6665C3.79008 8.6665 2.00008 6.8765 2.00008 4.6665C2.00008 2.4565 3.79008 0.666504 6.00008 0.666504C8.21008 0.666504 10.0001 2.4565 10.0001 4.6665C10.0001 6.8765 8.21008 8.6665 6.00008 8.6665ZM6.00008 7.33317C7.47341 7.33317 8.66675 6.13984 8.66675 4.6665C8.66675 3.19317 7.47341 1.99984 6.00008 1.99984C4.52675 1.99984 3.33341 3.19317 3.33341 4.6665C3.33341 6.13984 4.52675 7.33317 6.00008 7.33317ZM10.0001 11.3332V8.99984L13.3334 11.9998L10.0001 14.9998V12.6665H8.00008V11.3332H10.0001Z" fill="#6E6E6E"/>
          </svg>Falar com cliente</span>
      </div>
    </div>

    <div class="observation-container" [formGroup]="geralForm">
      
      <div class="separator"></div>
      <div class="history" [ngClass]="{'editing': isEditing}" [hidden]="activeTab !== 1">
        <app-fac-history-chat [activitiesOnly]="true" [facHistory]="facHistory"></app-fac-history-chat>
      </div>
      <div class="history" id="history-chat" [ngClass]="{'editing': isEditing}" [hidden]="activeTab !== 2">
        <app-client-chat (resend)="resendEmail($event)" [messages]="chatMessages"></app-client-chat>
      </div>
      <div class="floating-div">

        <div class="separator"></div>
        <ng-container *ngIf="isEditing">
          <div class="observation-box" [ngClass]="{error: (geralForm.invalid && activeTab === 1) || ((messageForm.invalid || (!messageForm.value.whatsapp && !messageForm.value.email)) && activeTab === 2 && messageForm.touched)}" >
            <div class="observation-inner" *ngIf="activeTab === 1">
                <div class="box-header" >
                    <div class="dropdown-container-obs">
                      <div class="dropdown-box" style="margin-right: 6px;" *ngIf="geralForm.get('column_type').value.value !== 'Sem Contato'">
                        <app-dropdown-button id="dropdown-fac-contact-type" [isOpen]="dropdownsState.contact" [label]="geralForm.get('contact_type').value ? geralForm.get('contact_type').value : 'Tipo de contato'" (valueChange)="dropdownsState.contact = $event">
                          <ul class="dropdown-text-list">
                            <li *ngFor="let contact of combosList.contact_types" (click)="setGeralFormValue('contact_type', contact);dropdownsState.contact = false">{{contact}}</li>
                          </ul>
                        </app-dropdown-button>
                      </div> 
    
                      <!-- New Return in -->
                      <div class="dropdown-box box-sm" (click)="dropdownsState.return_in = true" *ngIf="geralForm.get('column_type').value.value != 'Visita'"> 
                        <app-dropdown-input-list
                        [(isOpen)]="dropdownsState.return_in"
                        [list]="returnInList" 
                        [label]="returnInTitle ? returnInTitle : 'Retornar em'"
                        [currentValue]="{value: geralForm.get('return_date').value.value, name: geralForm.get('return_date').value.name}"
                        (closeModal)="dropdownsState.return_in = $event"
                        (valueChange)="formatReturnIn($event)"
                        (cleanValue)="clearReturn()">
                        </app-dropdown-input-list>
                      </div>
                      
                      <div class="icon-box-btn" [matTooltip]="'Anexos da fac'">
                        <div id="edit-fac-uploads" (click)="openFilesUploadModal()">
                          <img class="svg-icon" src="../../../../assets/svgs/anexo_ico.svg" alt="icon-anexo">
                        </div>
                        <div class="icon-box-count" *ngIf="geralForm && geralForm.get('attachments').value.length > 0">
                          <span>0{{ geralForm.get('attachments').value.length }}</span>
                        </div>
                      </div>
                      <div class="icon-box-btn" [matTooltip]="'Produtos ofertados'">
                        <div id="edit-fac-products" (click)="openSearchProductModal()">
                          <img class="svg-icon" src="../../../../assets/svgs/product_search.svg" alt="icon-search">
                        </div>
                        <div class="icon-box-count" *ngIf="geralForm && geralForm.get('products').value.length > 0">
                          <span>{{ geralForm.get('products').value.length > 9 ? '' : '0' }}{{ geralForm.get('products').value.length }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
          
                  <div class="inputs-container" *ngIf="geralForm.get('column_type').value.value === 'Visita'" [formGroup]="geralForm.get('visit_date')">
                    <lib-datepicker [date]="geralForm.get('visit_date').get('date').value" class="calendar-input-box" [placeholder]="'Data da visita'" format='dd/MM/yyyy' (dateChange)="geralForm.get('visit_date').get('date').patchValue($event)"></lib-datepicker>
                    <app-timepicker formControlName="hour" [placeholder]="'Horário'" (selectValue)="geralForm.get('visit_date').get('hour').patchValue($event)"></app-timepicker>
                  </div>
          
                  <textarea id="edit-fac-observation" class="observation-textarea" (keyup)="changeInput($event)" formControlName="description" placeholder="Digite comentários e observações" maxlength="800"></textarea>
            </div>
            <div class="observation-inner" *ngIf="activeTab === 2" [formGroup]="messageForm">
              <div class="box-header" >
                <div class="dropdown-container-obs">
                  <div class="email-msg-container">
                    <app-select 
                      id="dropdown-fac-email-msg"
                      inputHeight="36px"
                      height="235"
                      [listItems]="availableMessages"
                      sizeList="5"
                      placeholder="Mensagens pré-definidas"
                      (sendSearch)="setMessageType($event)"
                      field="title"
                      (clearDropDown)="clearChatForm()"
                      [isRelative]="true">
                    </app-select>
                  </div>
                  <div class="icon-box-btn" [matTooltip]="'Produtos ofertados'" *ngIf="false">
                    <div id="edit-fac-products" >
                      <img class="svg-icon" src="../../../../assets/svgs/product_search.svg" alt="icon-search">
                    </div>
                 </div>
                 <div id="email-checkbox" class="checkbox-container">
                   <lib-input-checkbox formControlName="email" [disabled]="!this.facItem.person.email"></lib-input-checkbox>
                   <img src="../../../../../assets/svgs/email_ico_gray.svg" alt="email_ico">
                   <span>Email</span>
                 </div>
                 <div id="whatsapp-checkbox" class="checkbox-container">
                  <lib-input-checkbox formControlName="whatsapp" [disabled]="!getClientWhatsapp()"></lib-input-checkbox>
                  <img src="../../../../../assets/svgs/whatsapp_ico.svg" alt="email_ico">
                  <span>WhatsApp</span>
                 </div>
                </div>
              </div>
              <textarea id="email-message-field" class="email-textarea" formControlName="message" placeholder="Falar com cliente" maxlength="800"></textarea>
            </div>
          </div>
    
          <div class="error-msg" *ngIf="geralForm.invalid && activeTab === 1">
            <lib-svg class="error-icon" [icon]="'error_alert_ico'"></lib-svg>
            <div [ngSwitch]="geralForm.get('column_type').value.value">
              <span *ngSwitchCase="'Visita'">Preencha tipo de contato, data de visita e digite um comentário</span>
              <span *ngSwitchCase="'Sem Contato'">Preencha a data de retorno e digite um comentário</span>
              <span *ngSwitchDefault>Preencha tipo de contato, data de retorno e digite um comentário</span>
            </div>
          </div>
          <div class="error-msg" *ngIf="(messageForm.invalid || (!messageForm.value.whatsapp && !messageForm.value.email))  && activeTab === 2 && messageForm.touched">
            <lib-svg class="error-icon" [icon]="'error_alert_ico'"></lib-svg>
            <div>
              <span>Selecione ou digite uma mensagem e escolha a forma de contato.</span>
            </div>
          </div>
        </ng-container>
  
        
      <div class="action-btn" *ngIf="isEditing && activeTab === 1">
        <lib-button-secondary id="edit-fac-save-obs" (click)="saveNotes()" [isDisabled]="geralForm.invalid || geralForm.pristine">
          Salvar registro
        </lib-button-secondary>
        <lib-button-tertiary (click)="isEditing = false;resetForm()">Cancelar</lib-button-tertiary>
      </div>
      <div class="action-btn" *ngIf="isEditing && activeTab === 2">
        <lib-button-secondary id="edit-fac-save-chat" (click)="sendMessageToClient()" [isDisabled]="messageForm.invalid || (!messageForm.value.whatsapp && !messageForm.value.email)">
          Enviar
        </lib-button-secondary>
        <lib-button-tertiary id="edit-fac-cancel-chat" (click)="isEditing = false;clearChatForm()">Cancelar</lib-button-tertiary>
      </div>
      <div class="edition-placeholder" *ngIf="!isEditing && activeTab === 1" (click)="isEditing = true">
        <span>Digite comentários e observações</span>
      </div>
      <div class="edition-placeholder" *ngIf="!isEditing && activeTab === 2 && (facItem.person.phone || facItem.person.email)" (click)="isEditing = true ">
        <span>Falar com cliente</span>
      </div>
    </div>
      </div>
  </div>

  <div class="right-container">
    <p id="lead-origin-btn" class="top-link" *ngIf="feature_lead_env" (click)="openOriginLead.emit()">
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M8 9.33335V10.6667C6.93914 10.6667 5.92172 11.0881 5.17158 11.8383C4.42143 12.5884 4.00001 13.6058 4.00001 14.6667H2.66667C2.66667 13.2522 3.22857 11.8956 4.22877 10.8954C5.22896 9.89526 6.58552 9.33335 8 9.33335ZM8 8.66669C5.79 8.66669 4.00001 6.87669 4.00001 4.66669C4.00001 2.45669 5.79 0.666687 8 0.666687C10.21 0.666687 12 2.45669 12 4.66669C12 6.87669 10.21 8.66669 8 8.66669ZM8 7.33335C9.47334 7.33335 10.6667 6.14002 10.6667 4.66669C10.6667 3.19335 9.47334 2.00002 8 2.00002C6.52667 2.00002 5.33334 3.19335 5.33334 4.66669C5.33334 6.14002 6.52667 7.33335 8 7.33335ZM14.2973 13.3547L15.3 14.3574L14.3573 15.3L13.3547 14.2974C12.7956 14.627 12.1354 14.7414 11.498 14.6192C10.8605 14.4969 10.2896 14.1464 9.89209 13.6333C9.49462 13.1202 9.29793 12.4797 9.33889 11.8319C9.37986 11.1842 9.65567 10.5736 10.1146 10.1146C10.5736 9.65569 11.1842 9.37988 11.8319 9.33891C12.4797 9.29794 13.1202 9.49463 13.6333 9.89211C14.1464 10.2896 14.4969 10.8606 14.6192 11.498C14.7414 12.1354 14.627 12.7956 14.2973 13.3547ZM12 13.3334C12.3536 13.3334 12.6928 13.1929 12.9428 12.9428C13.1929 12.6928 13.3333 12.3536 13.3333 12C13.3333 11.6464 13.1929 11.3073 12.9428 11.0572C12.6928 10.8072 12.3536 10.6667 12 10.6667C11.6464 10.6667 11.3072 10.8072 11.0572 11.0572C10.8071 11.3073 10.6667 11.6464 10.6667 12C10.6667 12.3536 10.8071 12.6928 11.0572 12.9428C11.3072 13.1929 11.6464 13.3334 12 13.3334Z" fill="#00866E"/>
      </svg>        
      Origem do lead
    </p>
    <p id="offered-products-btn" class="top-link" *ngIf="facItem.has_offered_products" (click)="openOfferedProduct.emit()">
      <svg width="14" height="12" viewBox="0 0 14 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12.6667 12H0.666667C0.489856 12 0.320286 11.9298 0.195262 11.8047C0.0702379 11.6797 3.99135e-09 11.5101 3.99135e-09 11.3333V6.32467C-1.04192e-05 6.22941 0.0203939 6.13525 0.0598385 6.04854C0.099283 5.96183 0.156852 5.88459 0.228667 5.822L2.66667 3.696V0.666667C2.66667 0.489856 2.7369 0.320286 2.86193 0.195262C2.98695 0.0702379 3.15652 0 3.33333 0H12.6667C12.8435 0 13.013 0.0702379 13.1381 0.195262C13.2631 0.320286 13.3333 0.489856 13.3333 0.666667V11.3333C13.3333 11.5101 13.2631 11.6797 13.1381 11.8047C13.013 11.9298 12.8435 12 12.6667 12ZM4.66667 10.6667H6.66667V6.628L4 4.30267L1.33333 6.628V10.6667H3.33333V8H4.66667V10.6667ZM8 10.6667H12V1.33333H4V2.75133C4.156 2.75133 4.31267 2.806 4.438 2.916L7.77133 5.822C7.84315 5.88459 7.90072 5.96183 7.94016 6.04854C7.97961 6.13525 8.00001 6.22941 8 6.32467V10.6667ZM9.33333 5.33333H10.6667V6.66667H9.33333V5.33333ZM9.33333 8H10.6667V9.33333H9.33333V8ZM9.33333 2.66667H10.6667V4H9.33333V2.66667ZM6.66667 2.66667H8V4H6.66667V2.66667Z" fill="#00866E"/>
      </svg>
      Produtos ofertados
    </p>
    <div class="icos-container" *ngIf="facItem.badges">
      <img *ngIf="formatedBadged.STAND" [matTooltip]="formatedBadged.STAND.description" src="../../../../assets/svgs/stand_fac_ico.svg" alt="stand_fac_ico">
      <img *ngIf="formatedBadged.BOUGHT" [matTooltip]="formatedBadged.BOUGHT.description" src="../../../../assets/svgs/bought_fac_ico.svg" alt="bought_fac_ico">
      <img *ngIf="formatedBadged.REAL_STATE_DEVELOPER_SELLER" [matTooltip]="formatedBadged.REAL_STATE_DEVELOPER_SELLER.description" src="../../../../assets/svgs/incorporator_fac_ico.svg" alt="incorporator_fac_ico">
    </div>

    <div class="input-container" *ngIf="facItem.person.phone">
      <p class="phone-title">Primeiro Telefone</p>
      <div id="edit-fac-first-phone" class="input-box">
        <div class="input-label">
          <app-flag-component class="icon" [icon]="facItem.person.phone.ddi"></app-flag-component>
          <p id="modal-fac-personal-phone">{{facItem.person.phone.ddi}} {{facItem.person.phone.phone | formatPhoneDDI: facItem.person.phone.ddi}}</p>
        </div>
        <div class="icon-box">
          <app-dropdown-icon id="dropdown-fac-first-phone" class="app-dropdown-icon" [isOpen]="dropdownsState.phone" [icon]="'phone_ico'" [iconTitle]="'Ações de telefone'" [alignRight]="true" (valueChange)="dropdownsState.phone = $event">
            <ul class="dropdown-text-list" (click)="dropdownsState.phone = false">
              <li (click)="copyPhone(facItem.person.phone);">Copiar</li>
              <li>    
                <a id="edit-fac-phonecall" href="#" (click)="makeCall(facItem.person.phone)">Ligar</a>
              </li>
              <li (click)="callWhats(facItem.person.phone)">WhatsApp</li>
            </ul>
          </app-dropdown-icon>
        </div>
      </div>
    </div>

    <div class="input-container mr-top-24" *ngIf="!showAdd.phone && facItem.person.alternative_phone">
      <p class="phone-title">Último Telefone</p>
      <div id="edit-fac-last-phone" class="input-box">
        <div class="input-label">
          <app-flag-component class="icon" [icon]="facItem.person.alternative_phone.ddi"></app-flag-component>
          <p id="modal-fac-alt-phone">{{facItem.person.alternative_phone.ddi}} {{facItem.person.alternative_phone.phone | formatPhoneDDI: facItem.person.alternative_phone.ddi}}</p>
        </div>       
        <div class="icon-box">
          <app-dropdown-icon id="dropdown-fac-last-phone" class="app-dropdown-icon" [isOpen]="dropdownsState.alternative_phone" [icon]="'phone_ico'" [iconTitle]="'Ações de telefone'" [alignRight]="true" (valueChange)="dropdownsState.alternative_phone= $event">
              <ul class="dropdown-text-list" (click)="dropdownsState.alternative_phone = false">
              <li (click)="copyPhone(facItem.person.alternative_phone)">Copiar</li>
              <li>    
                <a id="edit-fac-alternativephonecall" href="#" (click)="makeCall(facItem.person.alternative_phone)">Ligar</a>
              </li>
              <li (click)="callWhats(facItem.person.alternative_phone)">WhatsApp</li>
            </ul>
          </app-dropdown-icon>
        </div>
      </div>
    </div>

    <div class="input-container mr-top-24" *ngIf="showAdd.phone">
      <p class="phone-title">{{facItem.person.phone ? 'Último Telefone' : 'Primeiro Telefone'}}</p>
      <div class="input-box">
        <app-flag-input id="edit-fac-add-phone" class="email-input" [phone]="addPhone" (changes)="setPhone($event)" [invalid]="addPhone.invalid"></app-flag-input>
      </div>
      <div class="error-msg" *ngIf="addPhone.invalid">
        <lib-svg class="error-icon" [icon]="'error_alert_ico'"></lib-svg>
        <span>Telefone inválido</span>
      </div>
      <div class="options-box">
        <p (click)="addPhoneClick()">Adicionar</p>
        <p (click)="cancelPhoneClick()">Cancelar</p>
      </div>
    </div>

    <p id="fac-add-phone-btn" class="add-phone" (click)="showAdd.phone = true" *ngIf="!showAdd.phone">Adicionar telefone</p>

    <div class="input-container mr-top-24" *ngIf="facItem.person.email">
      <p class="phone-title">Primeiro E-mail</p>
      <div class="input-box">
        <p id="modal-fac-first-email">{{facItem.person.email}}</p>
        <div class="icon-box">
          <app-dropdown-icon id="dropdown-fac-email" class="app-dropdown-icon" [isOpen]="dropdownsState.email" [icon]="'email_ico'" [iconTitle]="'Ações de e-mail'" [alignRight]="true" (valueChange)="dropdownsState.email = $event">
            <ul class="dropdown-text-list" (click)="dropdownsState.email = false">
              <li (click)="geralService.copyToClipboard(facItem.person.email)">Copiar</li>
              <li>
                <a href="#" (click)="sendEmail(facItem.person.email)" class="external">Enviar e-mail</a>
              </li>
            </ul>
          </app-dropdown-icon>                       
        </div>
      </div>
    </div>

    <div class="input-container mr-top-24" *ngIf="!showAdd.email && facItem.person.alternative_email">
      <p class="phone-title">Último E-mail</p>
      <div class="input-box">
        <p id="modal-fac-alt-email">{{facItem.person.alternative_email}}</p>
        <div class="icon-box">
          <app-dropdown-icon class="app-dropdown-icon" [isOpen]="dropdownsState.alternative_email" [icon]="'email_ico'" [iconTitle]="'Ações de e-mail'" [alignRight]="true" (valueChange)="dropdownsState.alternative_email = $event">
            <ul class="dropdown-text-list" (click)="dropdownsState.alternative_email = false">
              <li (click)="geralService.copyToClipboard(facItem.person.alternative_email)">Copiar</li>
              <li>
                <a href="#" (click)="sendEmail(facItem.person.alternative_email)" class="external">Enviar e-mail</a>
              </li>
            </ul>
          </app-dropdown-icon>                       
        </div>     
      </div>
    </div>

    <div class="input-container mr-top-24" *ngIf="showAdd.email">
      <p class="phone-title">Último E-mail</p>
      <div class="input-box">
        <nav-input-login class="email-input" [(ngModel)]="addEmail.value" [placeholder]="'exemplo@email.com'" [invalid]="addEmail.invalid"></nav-input-login>    
      </div>
      <div class="error-msg" *ngIf="addEmail.invalid">
        <lib-svg class="error-icon" [icon]="'error_alert_ico'"></lib-svg>
        <span>E-mail inválido</span>
      </div>
      <div class="options-box">
        <p (click)="addEmailClick()">Adicionar</p>
        <p (click)="cancelEmailClick()">Cancelar</p>
      </div>
    </div>

    <p id="fac-add-email-btn" class="add-phone" (click)="showAdd.email = true" *ngIf="!showAdd.email">Adicionar e-mail</p>

    <div class="products-list">
      <p class="product-title">Produto de origem</p>
      <div class="product-description" *ngIf="facItem.origin_product">
        <div [innerHTML]="facItem.origin_product.description"></div>
        <div class="link-row">
          <p>{{facItem.origin_product.offer_date | date:'dd/MM/yyyy' : 'UTC'}} -</p>
          <a class="link" target="_blank" [href]="productUrl">&nbsp;Ficha do imóvel</a>
        </div>
      </div>
    </div>
  </div>
</div>

<app-discard-popup *ngIf="showDiscardPopup" (closeModal)="showDiscardPopup = false" (discartEvent)="discardFac($event)"></app-discard-popup>
<app-transfer-popup *ngIf="showTransferPopup" (closeModal)="showTransferPopup = false" (transferEvent)="transferFac($event)"></app-transfer-popup>